module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/7-7664d495337234ae7cf38b423672e7ce.jpg";